import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=74284abf&scoped=true&"
import script from "./Campus.vue?vue&type=script&lang=js&"
export * from "./Campus.vue?vue&type=script&lang=js&"
import style0 from "./Campus.vue?vue&type=style&index=0&id=74284abf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74284abf",
  null
  
)

export default component.exports